// extracted by mini-css-extract-plugin
export default {"spaceTypeToolbar":"tableView_spaceTypeToolbar__chmXw","tableCell":"tableView_tableCell__Yn0pJ","deleteSpace":"tableView_deleteSpace__93L2p"};